export default __webpack_public_path__ + "static/media/Icon-Menu-Feedback.d454e81a.svg";